import { createActionType } from 'app/store/utils';

const type = createActionType('assets');

export const SELECT_TARGET = type('SelectTarget');
export const UPDATE_ASSET_FILTER = type('UpdateAssetFilter');
